import React from 'react'
import blue from "../images/logo/Didari.svg"
export default function Logo(props){
    const logo = props.color ? props.color : blue;
        return (
            <div className="logo">
                <a href="/">
                    <img src={logo} alt="didari"/>
                </a>
            </div>
        )
}